/**
 * Stable CSS class names for E2E — Refund list V2 page.
 */
export const RLV2 = {
    page: 'refund-list-v2-page',
    breadcrumbSection: 'refund-list-v2-page__breadcrumb-section',
    loadingSection: 'refund-list-v2-page__loading-section',

    editDrawerPaper: 'refund-list-v2-page__edit-drawer-paper',
    addDrawerPaper: 'refund-list-v2-page__add-drawer-paper',

    resultsSection: 'refund-list-v2-page__results-section',
    downloadButtonWrap: 'refund-list-v2-page__download-button-wrap',
    dataGridWrap: 'refund-list-v2-page__data-grid-wrap',

    cellRefundId: 'refund-list-v2-page__cell-refund-id',
    linkRefundId: 'refund-list-v2-page-input--link-refund-id',
    cellDate: 'refund-list-v2-page__cell-date',
    cellOrderNumber: 'refund-list-v2-page__cell-order-number',
    linkOrderNumber: 'refund-list-v2-page-input--link-order-number',
    cellRmaCode: 'refund-list-v2-page__cell-rma-code',
    cellRefundReason: 'refund-list-v2-page__cell-refund-reason',
    cellRefundStatus: 'refund-list-v2-page__cell-refund-status',
    cellRefundMethod: 'refund-list-v2-page__cell-refund-method',
    cellCreditCardType: 'refund-list-v2-page__cell-credit-card-type',
    cellPaymentMerchantType: 'refund-list-v2-page__cell-payment-merchant-type',
    cellOperator: 'refund-list-v2-page__cell-operator',

    emptyState: 'refund-list-v2-page__empty-state',
    emptyNoRecord: 'refund-list-v2-page__empty-no-record',
    filterForm: 'refund-list-v2-page__filter-form',
    inputRefundId: 'refund-list-v2-input--refund-id',
    inputOrderNumber: 'refund-list-v2-input--order-number',
    selectRefundStatus: 'refund-list-v2-input--refund-status',
    selectRefundStatusItem: 'refund-list-v2-input--refund-status-item',
    dateRangeWrap: 'refund-list-v2-input--date-range-wrap',
    filterButton: 'refund-list-v2-input--button-filter',
} as const;

export const rlv2Cls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

